import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Collapse = ({ children, open = false }) => {
  const [isOpen, setIsOpen] = useState(open)
  const { t } = useTranslation()

  const toggleOpen = () => setIsOpen(!isOpen)

  const handleKeyDown = evt => {
    if (evt.keyCode === 13) {
      toggleOpen()
    }
  }

  return (
    <div className={styles.container}>
      <div
        className={`${styles.header} ${isOpen && styles.open}`}
        onClick={toggleOpen}
        onKeyDown={handleKeyDown}
        data-testid="collapse-header"
        role="button"
        tabIndex={0}
      >
        <FontAwesomeIcon icon={['far', 'caret-circle-down']} />
        {t(`general.${isOpen ? 'hide' : 'show'}Parameters`)}
      </div>
      {isOpen && <div className={styles.content}>{children}</div>}
    </div>
  )
}

export default Collapse
